module.exports = __webpack_public_path__ + "img/27_84.59c887ed.png";